export enum AssistantMode {
  Closed = 'closed',
  Open = 'open',
  Minimized = 'minimized',
}

export enum AssistantScreen {
  Chat = 'chat',
  History = 'history',
}

/**
 * Where the conversation list appears: its own screen reached from the header,
 * or a panel beside the chat that carries its own heading. Everything that
 * differs between the wide and narrow assistant follows from this rather than
 * from the display mode.
 */
export type HistoryPlacement = 'screen' | 'panel';

/**
 * `standalone` is the assistant rendered as the whole page (the `assistant`
 * build entry). It is never offered in the UI and never persisted: the entry
 * sets it at bootstrap.
 */
export type AssistantDisplayMode =
  | 'floating'
  | 'sidePanel'
  | 'fullScreen'
  | 'standalone';
export type AssistantDisplayModifier = 'expanded' | 'default';

export type AssistantBannerSource = 'featurePrompt' | 'uploadError';
export type AssistantBannerStatus = 'info' | 'error';

export type AssistantBanner = {
  id: string;
  source: AssistantBannerSource;
  status: AssistantBannerStatus;
  message: string;
};

export type NewAssistantBanner = Omit<AssistantBanner, 'id'>;

export type DismissedBanner = {
  bannerId: string;
  source: AssistantBannerSource;
};
